import { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { getGarageCoverImage, getGarageVehicleTitle } from "../../utils/vehicleDisplay";

function PublicBuildCard({ car, username }) {
  const [imageFailed, setImageFailed] = useState(false);
  const title = getGarageVehicleTitle(car);
  const image = getGarageCoverImage(car);
  const status = String(car.status || car.buildStatus || "").trim();
  const description = String(car.details || car.description || car.buildDescription || car.notes || "").trim();
  return (
    <Link className="public-build-card" to={`/user/${username}/car/${car.id}`} aria-label={`View ${title} build`}>
      <div className="public-build-card__cover">
        {image && !imageFailed ? <img src={image} alt={`${title} cover`} onError={() => setImageFailed(true)} /> : <div className="public-build-card__placeholder" role="img" aria-label={`${title} has no cover photo`}><span aria-hidden="true">▱</span>No photo yet</div>}
      </div>
      <div className="public-build-card__content">
        <div className="public-build-card__heading"><h3 title={title}>{title}</h3>{status && <span>{status.toUpperCase()}</span>}</div>
        {description && <p>{description}</p>}
        <strong>View Build <FiArrowRight aria-hidden="true" /></strong>
      </div>
    </Link>
  );
}
export default PublicBuildCard;
